// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1648457724395
      var cssReload = require("/home/system/myagent/_work/7/s/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"reloadAll":true,"import":true,"sourceMap":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  